//Definicao de classe publica
export class Contexto {
    constructor(
        public urlClienteQuasar: string,
        public database: string,
        public entity: string,
    ) { }
}
